define('helper-entity-isQuizGamePage',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (entity) {
        if (!entity || !entity.contentEntity || !entity.contentEntity.componentsJson || typeof entity.contentEntity.componentsJson !== 'string') {
            return false;
        }

        var arr = JSON.parse(entity.contentEntity.componentsJson) || [];

        return Array.isArray(arr) && arr.filter(function (o) {
            return o.kind && o.kind.toLowerCase() === 'quizgame' && o.content ? true : false;
        }).length ? true : false;
    };
});
